import React from 'react';

export const IcoGlobo = ({ ...props }) => {
  const style = props.style ? props.style : {};
  return (
    <svg
      className="icon-link-externo"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
      style={{ ...style, fill: '#323acb' }}
      aria-hidden="true"
    >
      <path d="M14 3h7v7h-2V6.414l-9.293 9.293-1.414-1.414L17.586 5H14V3z"/>
      <path d="M5 5h5V3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 
               2 2h14c1.103 0 2-.897 2-2v-5h-2v5H5V5z"/>
    </svg>
  );
};
